/* Lizenzexperte 2026 – theme.js
   Schlankes Vanilla-JS ohne Abhängigkeiten. Alle Funktionen sind progressive
   Verbesserungen: Ohne JavaScript funktionieren Suche, Warenkorb und Kauf weiterhin. */
(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- Geldformat ---------- */
  const formatMoney = (cents, format = T.moneyFormat || '{{amount}} €') => {
    const value = Number(cents) || 0;
    const num = (decimals, thousands, decimal) => {
      const [int, frac] = (value / 100).toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    const map = {
      amount: () => num(2, ',', '.'),
      amount_no_decimals: () => num(0, ',', '.'),
      amount_with_comma_separator: () => num(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => num(0, '.', ','),
      amount_with_apostrophe_separator: () => num(2, "'", '.'),
      amount_with_space_separator: () => num(2, ' ', ',')
    };
    return format
      .replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (map[key] || map.amount)())
      .replace(/([.,])00(?!\d)/, '');
  };

  /* ---------- Retro-Countdown (Fallblatt-Anzeige) ---------- */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FLIP_HTML = '<span class="flip__half flip__half--top"><span></span></span><span class="flip__half flip__half--bottom"><span></span></span>'
    + '<span class="flip__leaf flip__leaf--top"><span></span></span><span class="flip__leaf flip__leaf--bottom"><span></span></span>';

  const setFlip = (el, value, animate) => {
    const [top, bottom, leafTop, leafBottom] = $$(':scope > span > span', el);
    const old = el.dataset.v !== undefined ? el.dataset.v : top.textContent;
    el.dataset.v = value;
    if (!animate || reduceMotion || old === value) {
      top.textContent = value;
      bottom.textContent = value;
      return;
    }
    leafTop.textContent = old;
    leafBottom.textContent = value;
    top.textContent = value;
    bottom.textContent = old;
    el.classList.remove('is-flipping');
    void el.offsetWidth; // Animation neu starten
    el.classList.add('is-flipping');
    clearTimeout(el._flipTimer);
    el._flipTimer = setTimeout(() => {
      bottom.textContent = value;
      el.classList.remove('is-flipping');
    }, 620);
  };

  const setFlipUnit = (unit, text, animate) => {
    const wrap = $('[data-digits]', unit);
    let digits = Array.from(wrap.children);
    while (digits.length < text.length) {
      const d = document.createElement('span');
      d.className = 'flip';
      d.innerHTML = FLIP_HTML;
      wrap.prepend(d);
      digits = Array.from(wrap.children);
    }
    while (digits.length > text.length && digits.length > 2) {
      digits.shift().remove();
    }
    text.split('').forEach((ch, i) => setFlip(digits[i], ch, animate));
  };

  function initCountdowns(scope = document) {
    $$('[data-countdown]', scope).forEach((el) => {
      if (el._cdTimer) return;
      const mode = el.dataset.countdown;
      const fixedEnd = el.dataset.end ? new Date(el.dataset.end.trim().replace(' ', 'T')) : null;
      /* Optional: Ziel als Unix-Zeit, das nach Ablauf um „step“ Sekunden weiterspringt (z. B. jeden Tag
         um 0 Uhr), bis „stop“ erreicht ist. Meldet jeden Sprung als Ereignis „countdown:roll“. */
      const step = (Number(el.dataset.step) || 0) * 1000;
      const stop = (Number(el.dataset.stop) || 0) * 1000;
      let target = (Number(el.dataset.target) || 0) * 1000;
      const getEnd = () => {
        if (target) {
          if (step && target <= Date.now() && (!stop || target < stop)) {
            while (target <= Date.now() && (!stop || target < stop)) target += step;
            el.dispatchEvent(new CustomEvent('countdown:roll', { bubbles: true, detail: { target, last: !!stop && target >= stop } }));
          }
          return new Date(target);
        }
        if (mode === 'date' && fixedEnd && !isNaN(fixedEnd)) return fixedEnd;
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
      };
      const units = $$('[data-unit]', el);
      const asText = el.dataset.format === 'text';
      const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
      let first = true;
      let lastMinute = -1;
      const tick = () => {
        if (!el.isConnected) { clearInterval(el._cdTimer); return; }
        const left = getEnd() - new Date();
        if (left <= 0 && mode === 'date') {
          const box = el.closest('[data-deal]') || el.closest('.product-timer, .feature__timer, .qb__timer');
          if (box) box.hidden = true;
          clearInterval(el._cdTimer);
          el._cdTimer = -2;
          return;
        }
        const t = Math.max(0, left);
        const v = { d: Math.floor(t / 864e5), h: Math.floor(t / 36e5) % 24, m: Math.floor(t / 6e4) % 60, s: Math.floor(t / 1e3) % 60 };
        if (asText) {
          el.textContent = `${v.d > 0 ? `${v.d} ${T.strings.daysShort || 'T'} ` : ''}${pad(v.h)}:${pad(v.m)}:${pad(v.s)}`;
        } else {
          units.forEach((unit) => setFlipUnit(unit, pad(v[unit.dataset.unit]), !first));
        }
        if (v.m !== lastMinute) {
          lastMinute = v.m;
          el.setAttribute('aria-label', `Countdown: noch ${v.d} Tage, ${v.h} Stunden und ${v.m} Minuten`);
        }
        first = false;
      };
      el._cdTimer = -1;
      tick();
      if (el._cdTimer === -1) el._cdTimer = setInterval(tick, 1000);
    });
  }

  /* ---------- Aktionsleiste: aufklappen & schließen ---------- */
  function initDeal(scope = document) {
    $$('[data-deal]', scope).forEach((deal) => {
      if (deal._dealReady) return;
      deal._dealReady = true;
      const key = `lx-deal-closed-${deal.dataset.dealKey || ''}`;
      /* Im Theme-Editor bleibt die Leiste immer sichtbar, auch wenn sie in dieser Sitzung schon geschlossen wurde. */
      const inEditor = !!(window.Shopify && window.Shopify.designMode);
      try { if (!inEditor && sessionStorage.getItem(key)) { deal.hidden = true; return; } } catch (e) { /* Speicher blockiert */ }

      $$('[data-promo-close]', deal).forEach((btn) => btn.addEventListener('click', (e) => {
        e.stopPropagation();
        deal.hidden = true;
        if (inEditor) return;
        try { sessionStorage.setItem(key, '1'); } catch (err) { /* Speicher blockiert */ }
      }));

      const panel = $('[data-deal-panel]', deal);
      const toggles = $$('[data-deal-toggle]', deal);
      if (!panel || !toggles.length) return;
      const set = (open) => {
        deal.classList.toggle('is-open', open);
        panel.inert = !open;
        panel.setAttribute('aria-hidden', String(!open));
        toggles.forEach((b) => {
          b.setAttribute('aria-expanded', String(open));
          const label = $('[data-more]', b);
          if (label) label.textContent = open ? label.dataset.less : label.dataset.more;
        });
      };
      toggles.forEach((b) => b.addEventListener('click', (e) => {
        e.stopPropagation();
        set(!deal.classList.contains('is-open'));
      }));
      const bar = $('.deal__bar', deal);
      if (bar) bar.addEventListener('click', (e) => {
        if (e.target.closest('a, button')) return;
        set(!deal.classList.contains('is-open'));
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && deal.isConnected && deal.classList.contains('is-open')) set(false);
      });
    });
  }

  /* Theme-Editor: neu gerenderte Sections (z. B. nach einer geänderten Einstellung) wieder lebendig machen */
  document.addEventListener('shopify:section:load', (e) => {
    initCountdowns(e.target);
    initDeal(e.target);
  });

  /* ---------- Schwebende Fremd-Widgets (Chat, Trusted Shops, Cookie-Button) ausblenden, solange eine Seitenleiste offen ist ---------- */
  const floatingWidgets = {
    hidden: [],
    isFloating(el) {
      const pos = getComputedStyle(el).position;
      return pos === 'fixed' || pos === 'sticky';
    },
    collect(root, keep, depth, found) {
      Array.from(root.children).forEach((el) => {
        if (el === keep || el.contains(keep) || keep.contains(el)) return;
        if (/^(SCRIPT|STYLE|LINK|META|NOSCRIPT|TEMPLATE|HEAD|BODY|MAIN)$/.test(el.tagName)) return;
        if (el.matches('[data-deal], .shopify-section-group-header-group, .shopify-section-group-footer-group, .skip-link, .drawer, .cdrawer')) return;
        if (this.isFloating(el)) { found.push(el); return; }
        if (depth > 0) this.collect(el, keep, depth - 1, found);
      });
      return found;
    },
    hide(keep) {
      this.show();
      const found = this.collect(document.body, keep, 2, []);
      this.collect(document.documentElement, keep, 1, found);
      found.forEach((el) => {
        this.hidden.push([el, el.style.getPropertyValue('visibility'), el.style.getPropertyPriority('visibility')]);
        el.style.setProperty('visibility', 'hidden', 'important');
      });
    },
    show() {
      this.hidden.forEach(([el, value, prio]) => {
        if (value) el.style.setProperty('visibility', value, prio); else el.style.removeProperty('visibility');
      });
      this.hidden = [];
    }
  };

  /* ---------- Mobile-Menü mit Unterebenen ---------- */
  function initDrawer() {
    const drawer = $('#menu-drawer');
    if (!drawer) return;
    const openers = $$('[data-drawer-open]');
    const main = $('[data-drawer-view="main"]', drawer);
    let lastFocus = null;
    let current = main;

    const showView = (view, back = false) => {
      if (!view || view === current) return;
      const prev = current;
      prev.classList.remove('is-active');
      prev.classList.toggle('is-behind', !back && prev === main);
      prev.inert = true;
      prev.setAttribute('aria-hidden', 'true');
      view.classList.remove('is-behind');
      view.classList.add('is-active');
      view.inert = false;
      view.setAttribute('aria-hidden', 'false');
      current = view;
      const scroller = $('.drawer__body', view);
      if (scroller && !back) scroller.scrollTop = 0;
    };

    const resetViews = () => {
      $$('[data-drawer-view]', drawer).forEach((v) => {
        const isMain = v === main;
        v.classList.toggle('is-active', isMain);
        v.classList.remove('is-behind');
        v.inert = !isMain;
        v.setAttribute('aria-hidden', String(!isMain));
      });
      $$('[data-drawer-sub]', drawer).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      current = main;
    };

    const open = () => {
      lastFocus = document.activeElement;
      resetViews();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('no-scroll');
      floatingWidgets.hide(drawer);
      const closeBtn = $('[data-drawer-close].drawer__close', main);
      if (closeBtn) setTimeout(() => closeBtn.focus({ preventScroll: true }), 50);
    };
    const close = () => {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('no-scroll');
      floatingWidgets.show();
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    };

    openers.forEach((b) => b.addEventListener('click', open));
    $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
    $$('[data-drawer-sub]', drawer).forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = document.getElementById(btn.dataset.drawerSub);
        if (!view) return;
        btn.setAttribute('aria-expanded', 'true');
        view._opener = btn;
        showView(view);
        const back = $('[data-drawer-back]', view);
        if (back) setTimeout(() => back.focus({ preventScroll: true }), 50);
      });
    });
    $$('[data-drawer-back]', drawer).forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.closest('[data-drawer-view]');
        showView(main, true);
        if (view && view._opener) {
          view._opener.setAttribute('aria-expanded', 'false');
          setTimeout(() => view._opener.focus({ preventScroll: true }), 50);
        }
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
      if (current !== main) { const back = $('[data-drawer-back]', current); if (back) back.click(); }
      else close();
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => { if (e.matches) close(); });
  }

  /* ---------- Live-Suche ---------- */
  function initPredictiveSearch() {
    $$('[data-predictive-search]').forEach((wrap) => {
      const input = $('input[name="q"]', wrap);
      const results = $('[data-predictive-results]', wrap);
      if (!input || !results || !T.routes.predictiveSearch) return;
      let controller;
      let timeout;
      const hide = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      input.addEventListener('input', () => {
        clearTimeout(timeout);
        const q = input.value.trim();
        if (q.length < 2) { hide(); return; }
        timeout = setTimeout(async () => {
          if (controller) controller.abort();
          controller = new AbortController();
          try {
            const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor&section_id=predictive-search`;
            const res = await fetch(url, { signal: controller.signal });
            if (!res.ok) return;
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            const inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = !inner;
            input.setAttribute('aria-expanded', String(Boolean(inner)));
          } catch (e) { /* abgebrochen */ }
        }, 220);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') hide();
        if (e.key === 'ArrowDown' && !results.hidden) {
          const first = $('a', results);
          if (first) { e.preventDefault(); first.focus(); }
        }
      });
      results.addEventListener('keydown', (e) => {
        const links = $$('a', results);
        const i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? links[i - 1] : input).focus(); }
        if (e.key === 'Escape') { hide(); input.focus(); }
      });
      document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) hide(); });
    });
  }

  /* ---------- Warenkorb ---------- */
  const setCartCount = (count) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
  };

  const refreshCart = async () => {
    const res = await fetch(`${T.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    setCartCount(cart.item_count);
    return cart;
  };

  /* ---------- Warenkorb-Seitenleiste ---------- */
  const cartDrawer = {
    el: null,
    open() {
      const el = this.el;
      if (!el) { window.location.href = T.routes.cart; return; }
      const menuClose = $('#menu-drawer.is-open [data-drawer-close]');
      if (menuClose) menuClose.click();
      this.lastFocus = document.activeElement;
      // Ans Ende der Seite verschieben, damit keine schwebenden Widgets (z. B. Trusted Shops) darüber liegen
      if (el.parentElement !== document.body || el.nextElementSibling) {
        document.body.appendChild(el);
        void el.offsetWidth;
      }
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      floatingWidgets.hide(el);
      const close = $('.cdrawer__close', el);
      if (close) setTimeout(() => close.focus({ preventScroll: true }), 60);
    },
    close() {
      const el = this.el;
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      floatingWidgets.show();
      if (this.lastFocus) this.lastFocus.focus({ preventScroll: true });
    },
    render(html) {
      if (!html || !this.el) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-inner]');
      const current = $('[data-cart-inner]', this.el);
      if (fresh && current) current.replaceWith(fresh);
      if (fresh) setCartCount(fresh.dataset.count);
    },
    async refresh() {
      if (!this.el) return;
      const id = this.el.dataset.sectionId;
      const res = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(id)}`);
      if (res.ok) this.render((await res.json())[id]);
    },
    async change(line, quantity) {
      const el = this.el;
      const id = el.dataset.sectionId;
      el.classList.add('is-busy');
      try {
        const res = await fetch(`${T.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: [id], sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || T.strings.cartError);
        if (data.sections) this.render(data.sections[id]);
        else await this.refresh();
      } catch (err) {
        window.alert(err.message || T.strings.cartError);
        await this.refresh();
      } finally {
        el.classList.remove('is-busy');
      }
    }
  };

  function initCartDrawer() {
    cartDrawer.el = $('[data-cart-drawer]');
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-open]') && cartDrawer.el) { e.preventDefault(); cartDrawer.open(); return; }
      const drawer = e.target.closest('[data-cart-drawer]');
      if (!drawer) return;
      if (e.target.closest('[data-cart-close]')) { cartDrawer.close(); return; }
      const item = e.target.closest('[data-line]');
      if (!item) return;
      const line = Number(item.dataset.line);
      const input = $('[data-cart-qty]', item);
      const step = e.target.closest('[data-cart-step]');
      if (step) cartDrawer.change(line, Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.cartStep)));
      if (e.target.closest('[data-cart-remove]')) cartDrawer.change(line, 0);
    });
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-drawer] [data-cart-qty]');
      if (!input) return;
      cartDrawer.change(Number(input.closest('[data-line]').dataset.line), Math.max(0, parseInt(input.value, 10) || 0));
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cartDrawer.close(); });
    // Theme-Editor: neu gerenderte Seitenleiste übernehmen
    document.addEventListener('shopify:section:load', (e) => {
      const fresh = e.target.querySelector('[data-cart-drawer]');
      if (!fresh) return;
      if (cartDrawer.el && cartDrawer.el !== fresh) cartDrawer.el.remove();
      cartDrawer.el = fresh;
    });
    // Theme-Editor: Seitenleiste öffnen, solange sie links ausgewählt ist
    const isCartSection = (e) => cartDrawer.el && e.detail && e.detail.sectionId === cartDrawer.el.dataset.sectionId;
    document.addEventListener('shopify:section:select', (e) => { if (isCartSection(e)) cartDrawer.open(); });
    document.addEventListener('shopify:section:deselect', (e) => { if (isCartSection(e)) cartDrawer.close(); });
  }

  function initProductForms() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      const button = e.submitter && e.submitter.type === 'submit' ? e.submitter : $('[type="submit"]', form);
      const error = $('[data-form-error]', form);
      if (error) error.hidden = true;
      if (button) button.classList.add('is-loading');
      try {
        const res = await fetch(`${T.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        if (cartDrawer.el) {
          await cartDrawer.refresh();
          cartDrawer.open();
        } else {
          await refreshCart();
          window.location.href = T.routes.cart;
        }
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
        else window.alert(err.message);
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    });

  }

  /* ---------- Mengenauswahl & Warenkorbseite ---------- */
  function initQuantity() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-btn]');
      if (!btn) return;
      const input = $('input', btn.closest('.qty'));
      if (!input) return;
      const min = parseInt(input.min || '0', 10);
      const step = btn.dataset.qtyBtn === 'plus' ? 1 : -1;
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    $$('[data-cart-form] input[name="updates[]"]').forEach((input) => {
      input.addEventListener('change', () => {
        clearTimeout(input._timer);
        input._timer = setTimeout(() => input.form.submit(), 600);
      });
    });
  }

  /* ---------- Variantenauswahl ---------- */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach((picker) => {
      const root = picker.closest('[data-product-root]');
      const json = root && $('[data-product-json]', root);
      if (!json) return;
      const product = JSON.parse(json.textContent);
      const idInput = $('form[data-product-form] input[name="id"]', root);
      const fieldsets = $$('fieldset', picker);

      picker.addEventListener('change', () => {
        const selected = fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
        fieldsets.forEach((fs, i) => { const label = $('[data-selected]', fs); if (label) label.textContent = selected[i]; });
        const variant = product.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        const buttons = $$('[data-add-button]', root);

        if (!variant) {
          buttons.forEach((b) => { b.disabled = true; const s = $('span', b); if (s) s.textContent = T.strings.unavailable; });
          return;
        }
        if (idInput) idInput.value = variant.id;

        const onSale = variant.compare_at_price > variant.price;
        $$('[data-price]', root).forEach((el) => {
          const current = $('[data-price-current]', el);
          const compare = $('[data-price-compare]', el);
          if (current) current.innerHTML = formatMoney(variant.price);
          el.classList.toggle('price--sale', onSale);
          if (compare) { compare.innerHTML = onSale ? formatMoney(variant.compare_at_price) : ''; compare.hidden = !onSale; }
        });
        $$('[data-discount-badge]', root).forEach((badge) => {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = `-${Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)} %`;
        });
        $$('[data-save]', root).forEach((el) => {
          el.hidden = !onSale;
          if (onSale) el.textContent = (T.strings.save || '').replace('[amount]', formatMoney(variant.compare_at_price - variant.price).replace(/<[^>]*>/g, ''));
        });
        buttons.forEach((b) => {
          b.disabled = !variant.available;
          const s = $('span', b);
          if (s) s.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
        });
        $$('[data-stock]', root).forEach((el) => {
          el.classList.toggle('is-out', !variant.available);
          el.textContent = variant.available ? T.strings.inStock : T.strings.soldOut;
        });
        root.dispatchEvent(new CustomEvent('variant:change', { detail: variant, bubbles: true }));
        if (picker.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (variant.featured_media) {
          const thumb = $(`[data-media-id="${variant.featured_media.id}"]`, root);
          if (thumb) thumb.click();
        }
      });
    });
  }

  /* ---------- Produktgalerie ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach((gallery) => {
      const main = $('.gallery__main img', gallery);
      if (!main) return;
      $$('[data-media-id]', gallery).forEach((thumb) => {
        thumb.addEventListener('click', () => {
          $$('[data-media-id]', gallery).forEach((t) => t.setAttribute('aria-current', 'false'));
          thumb.setAttribute('aria-current', 'true');
          main.removeAttribute('srcset');
          main.src = thumb.dataset.src;
          main.alt = thumb.dataset.alt || '';
        });
      });
    });
  }

  /* ---------- Produkt-Slider ---------- */
  function initSliders(scope = document) {
    $$('[data-slider]', scope).forEach((wrap) => {
      if (wrap.dataset.sliderReady) return;
      wrap.dataset.sliderReady = '1';
      const track = $('[data-slider-track]', wrap);
      if (!track) return;
      const navs = $$('[data-slider-prev], [data-slider-next]', wrap);
      navs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = btn.hasAttribute('data-slider-next') ? 1 : -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
        });
      });
      /* Pfeile nur zeigen, wenn es wirklich etwas zum Blättern gibt (z. B. nicht bei nur einem Banner) */
      const updateNav = () => {
        const fits = track.scrollWidth <= track.clientWidth + 4;
        navs.forEach((btn) => { btn.hidden = fits; });
      };
      updateNav();
      window.addEventListener('resize', updateNav, { passive: true });
      window.addEventListener('load', updateNav, { once: true });
    });
  }

  /* ---------- Empfehlungen nachladen ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(async (el) => {
      if ($('.p-card', el) || !el.dataset.url) return;
      try {
        const res = await fetch(el.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initSliders(el);
        }
      } catch (e) { /* keine Empfehlungen */ }
    });
  }

  /* ---------- Sticky-Kaufleiste (mobil) ----------
     Die Leiste wird ans Ende von <body> gehängt und hat den höchsten z-index: So liegt sie über Chat- und
     Cookie-Knopf (gleicher z-index, das spätere Element gewinnt). Ist etwas Größeres offen – Warenkorb-Seitenleiste,
     Menü, Chatfenster, Cookie-Hinweis oder ein Fenster, das das Scrollen sperrt –, blendet sie sich aus. */
  let stickyAtcCleanup = null;
  function initStickyAtc() {
    if (stickyAtcCleanup) stickyAtcCleanup();
    const bar = $('[data-product-root] ~ [data-sticky-atc]') || $('[data-sticky-atc]');
    $$('body > [data-sticky-atc]').forEach((old) => { if (old !== bar) old.remove(); });
    const target = $('[data-product-root] [data-add-button]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    const html = document.documentElement;
    const mobile = window.matchMedia('(max-width: 989px)');
    let wanted = false;
    let showTimer = 0;
    let poll = 0;
    let moves = [];

    // Am Ende von <body> halten, auch wenn Apps später eigene Elemente anhängen
    // (bricht ab, falls ein anderes Skript dasselbe tut und sich beide ständig gegenseitig verdrängen)
    const keepLast = () => {
      if (document.body.lastElementChild === bar) return;
      const now = Date.now();
      moves = moves.filter((t) => now - t < 3000);
      if (moves.length > 15) return;
      moves.push(now);
      document.body.appendChild(bar);
    };
    keepLast();
    const bodyObserver = new MutationObserver(keepLast);
    bodyObserver.observe(document.body, { childList: true });

    const shown = (el) => {
      if (!el) return false;
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1) return false;
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    };
    const cookieDialogOpen = () => {
      const cmp = $('pandectes-cmp');
      const sr = cmp && cmp.shadowRoot;
      if (!sr) return false;
      return Array.from(sr.querySelectorAll('*')).some((el) => {
        if (/^(STYLE|SCRIPT|LINK)$/.test(el.tagName) || el.closest('.widget')) return false;
        const r = el.getBoundingClientRect();
        return r.width > 120 && r.height > 80 && shown(el);
      });
    };
    const blocked = () => {
      const body = document.body;
      if (body.classList.contains('no-scroll') || $('.cdrawer.is-open, .drawer.is-open')) return true;
      if (getComputedStyle(body).overflowY === 'hidden' || getComputedStyle(html).overflowY === 'hidden') return true;
      if (shown($('.aibot-window')) || shown($('#wb-modal-overlay'))) return true;
      return cookieDialogOpen();
    };
    const paint = () => {
      const on = wanted && mobile.matches && !bar.classList.contains('is-blocked');
      bar.setAttribute('aria-hidden', String(!on));
      html.classList.toggle('has-sticky-atc', on);
    };
    const update = () => {
      if (blocked()) {
        clearTimeout(showTimer);
        showTimer = 0;
        bar.classList.add('is-blocked');
      } else if (bar.classList.contains('is-blocked') && !showTimer) {
        // kurz warten, bis z. B. die Seitenleiste ganz hinausgefahren ist
        showTimer = setTimeout(() => {
          showTimer = 0;
          if (!blocked()) bar.classList.remove('is-blocked');
          paint();
        }, 350);
      }
      paint();
      // Solange die Leiste gebraucht wird, regelmäßig prüfen (Chatfenster und Cookie-Hinweis melden sich nicht)
      if (wanted && mobile.matches && !poll) poll = setInterval(update, 700);
      if ((!wanted || !mobile.matches) && poll) { clearInterval(poll); poll = 0; }
    };

    const io = new IntersectionObserver(([entry]) => {
      wanted = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', wanted);
      update();
    });
    io.observe(target);
    const attrObserver = new MutationObserver(update);
    attrObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    attrObserver.observe(html, { attributes: true, attributeFilter: ['style'] });
    const soon = () => { setTimeout(update, 80); setTimeout(update, 450); };
    document.addEventListener('click', soon, true);
    document.addEventListener('keydown', soon, true);
    const onMedia = () => update();
    if (mobile.addEventListener) mobile.addEventListener('change', onMedia);

    // Variantenwechsel: Preis und Verfügbarkeit in der Leiste mitziehen
    const onVariant = (e) => {
      const variant = e.detail;
      if (!variant) return;
      const button = $('[data-sticky-add]', bar);
      if (button) button.disabled = !variant.available;
      const onSale = variant.compare_at_price > variant.price;
      $$('[data-price]', bar).forEach((el) => {
        const current = $('[data-price-current]', el);
        const compare = $('[data-price-compare]', el);
        if (current) current.innerHTML = formatMoney(variant.price);
        el.classList.toggle('price--sale', onSale);
        if (compare) { compare.innerHTML = onSale ? formatMoney(variant.compare_at_price) : ''; compare.hidden = !onSale; }
      });
    };
    document.addEventListener('variant:change', onVariant);

    stickyAtcCleanup = () => {
      io.disconnect();
      bodyObserver.disconnect();
      attrObserver.disconnect();
      clearInterval(poll);
      clearTimeout(showTimer);
      document.removeEventListener('click', soon, true);
      document.removeEventListener('keydown', soon, true);
      document.removeEventListener('variant:change', onVariant);
      if (mobile.removeEventListener) mobile.removeEventListener('change', onMedia);
      html.classList.remove('has-sticky-atc');
      stickyAtcCleanup = null;
    };
  }
  // Theme-Editor: Produkt-Section neu geladen oder entfernt
  document.addEventListener('shopify:section:unload', (e) => {
    if (!$('[data-product-root]', e.target) || !stickyAtcCleanup) return;
    stickyAtcCleanup();
    $$('body > [data-sticky-atc]').forEach((el) => el.remove());
  });
  document.addEventListener('shopify:section:load', (e) => {
    if ($('[data-sticky-atc]', e.target)) initStickyAtc();
  });

  /* ---------- Aufklappbare SEO-Texte ---------- */
  function initCollapsibles() {
    $$('[data-collapsible]').forEach((wrap) => {
      const content = $('[data-collapsible-content]', wrap);
      const btn = $('[data-collapsible-toggle]', wrap);
      if (!content || !btn) return;
      if (content.scrollHeight <= content.clientHeight + 60) {
        wrap.classList.remove('is-collapsible');
        btn.hidden = true;
        return;
      }
      btn.addEventListener('click', () => {
        const open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        const label = $('span', btn);
        if (label) label.textContent = open ? btn.dataset.less : btn.dataset.more;
        if (!open) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Filter & Sortierung ---------- */
  function initFilters() {
    $$('[data-filter-form]').forEach((form) => {
      form.addEventListener('change', (e) => { if (e.target.matches('input[type="checkbox"]')) form.submit(); });
    });
    $$('[data-filter-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = document.getElementById(btn.getAttribute('aria-controls'));
        if (!target) return;
        const open = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
    $$('[data-sort-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Mengenrabatt (Staffelpreise) als Stufen ---------- */
  function initQuantityBreaks() {
    $$('[data-qb]').forEach((qb) => {
      const root = qb.closest('[data-product-root]') || document;
      const radios = $$('input[type="radio"]', qb);
      const customInput = $('[data-qb-custom]', qb);
      const customRadio = $('[data-qb-custom-radio]', qb);
      const customWrap = $('[data-qb-custom-wrap]', qb);
      const tiers = radios.filter((r) => r.value !== 'custom')
        .map((r) => ({ qty: Number(r.value), discount: Number(r.dataset.discount) || 0, radio: r }))
        .sort((a, b) => a.qty - b.qty);
      const S = T.strings || {};
      const part = (key) => $('[data-qb-' + key + ']', qb);
      let price = Number(qb.dataset.price) || 0;
      let compare = Number(qb.dataset.compare) || 0;
      const money = (cents) => formatMoney(Math.round(cents)).replace(/<[^>]*>/g, '');
      const discountFor = (qty) => tiers.reduce((d, t) => (qty >= t.qty ? t.discount : d), 0);

      const paint = () => {
        const checked = radios.find((r) => r.checked) || radios[0];
        const isCustom = Boolean(checked && checked.value === 'custom');
        const qty = isCustom ? Math.max(1, parseInt(customInput.value, 10) || 1) : Number(checked ? checked.value : 1);
        const discount = isCustom ? discountFor(qty) : Number(checked.dataset.discount) || 0;
        const unitNet = Math.round((price * (100 - discount)) / 100);
        const save = (price - unitNet) * qty;

        part('sum-qty').textContent = (S.qbPieces || '[n]').replace('[n]', qty);
        part('sum-total').textContent = money(unitNet * qty);
        const saveEl = part('sum-save');
        saveEl.textContent = (S.save || '[amount]').replace('[amount]', money(save));
        saveEl.hidden = !(save > 0);

        const summary = $('.qb__summary', qb);
        if (summary) summary.classList.toggle('has-deal', isCustom || discount > 0 || !part('hint'));
        qb.classList.toggle('is-custom', isCustom);
        if (customWrap) customWrap.hidden = !isCustom;
        part('sum-qty').hidden = isCustom;
        return qty;
      };

      const sync = () => {
        const qty = paint();
        $$('form[data-product-form] input[name="quantity"]', root).forEach((input) => { input.value = qty; });
      };

      qb.addEventListener('change', (e) => {
        if (e.target === customRadio && customInput) {
          const current = tiers.find((t) => t.radio.checked);
          customInput.value = Math.max(Number(customInput.value) || 1, tiers.length ? tiers[tiers.length - 1].qty + 1 : 1);
          if (current) customInput.value = Math.max(Number(customInput.value), current.qty);
        }
        sync();
      });
      qb.addEventListener('click', (e) => {
        const step = e.target.closest('[data-qb-step]');
        if (!step) return;
        customInput.value = Math.max(1, (parseInt(customInput.value, 10) || 1) + Number(step.dataset.qbStep));
        customRadio.checked = true;
        sync();
      });
      if (customInput) customInput.addEventListener('input', () => { customRadio.checked = true; sync(); });
      root.addEventListener('variant:change', (e) => {
        price = e.detail.price;
        compare = e.detail.compare_at_price || 0;
        paint();
      });
      sync();
    });
  }

  initCountdowns();
  initDeal();
  initCartDrawer();
  initDrawer();
  initPredictiveSearch();
  initProductForms();
  initQuantity();
  initVariantPickers();
  initGallery();
  initSliders();
  initRecommendations();
  initStickyAtc();
  initCollapsibles();
  initFilters();
  initQuantityBreaks();
})();
